export default {
  list: [
    { name: 'Acehnese', key: 'ace' },
    { name: 'Acholi', key: 'ach' },
    { name: 'Afrikaans', key: 'af' },
    { name: 'Albanian', key: 'sq' },
    { name: 'Alur', key: 'alz' },
    { name: 'Amharic', key: 'am' },
    { name: 'Arabic', key: 'ar' },
    { name: 'Armenian', key: 'hy' },
    { name: 'Assamese', key: 'as' },
    { name: 'Awadhi', key: 'awa' },
    { name: 'Aymara', key: 'ay' },
    { name: 'Azerbaijani', key: 'az' },
    { name: 'Balinese', key: 'ban' },
    { name: 'Bambara', key: 'bm' },
    { name: 'Bashkir', key: 'ba' },
    { name: 'Basque', key: 'eu' },
    { name: 'Batak Simalungun', key: 'bts' },
    { name: 'Batak Toba', key: 'bbc' },
    { name: 'Belarusian', key: 'be' },
    { name: 'Bemba', key: 'bem' },
    { name: 'Bengali', key: 'bn' },
    { name: 'Betawi', key: 'bew' },
    { name: 'Bhojpuri', key: 'bho' },
    { name: 'Bikol', key: 'bik' },
    { name: 'Bosnian', key: 'bs' },
    { name: 'Breton', key: 'br' },
    { name: 'Bulgarian', key: 'bg' },
    { name: 'Cantonese', key: 'yue' },
    { name: 'Catalan', key: 'ca' },
    { name: 'Cebuano', key: 'ceb' },
    { name: 'Chichewa (Nyanja)', key: 'ny' },
    { name: 'Chinese (Simplified)', key: 'zh' },
    { name: 'Chinese (Traditional)', key: 'zh-TW' },
    { name: 'Chuvash', key: 'cv' },
    { name: 'Croatian', key: 'hr' },
    { name: 'Czech', key: 'cs' },
    { name: 'Danish', key: 'da' },
    { name: 'Dinka', key: 'din' },
    { name: 'Dogri', key: 'doi' },
    { name: 'Dutch', key: 'nl' },
    { name: 'English', key: 'en' },
    { name: 'Estonian', key: 'et' },
    { name: 'Ewe', key: 'ee' },
    { name: 'Filipino', key: 'fil' },
    { name: 'Finnish', key: 'fi' },
    { name: 'French', key: 'fr' },
    { name: 'French (Canadian)', key: 'fr-CA' },
    { name: 'Frisian', key: 'fy' },
    { name: 'Fulfulde', key: 'ff' },
    { name: 'Ga', key: 'gaa' },
    { name: 'Galician', key: 'gl' },
    { name: 'Ganda (Luganda)', key: 'lg' },
    { name: 'Georgian', key: 'ka' },
    { name: 'German', key: 'de' },
    { name: 'Greek', key: 'el' },
    { name: 'Guarani', key: 'gn' },
    { name: 'Gujarati', key: 'gu' },
    { name: 'Haitian Creole', key: 'ht' },
    { name: 'Hausa', key: 'ha' },
    { name: 'Hebrew', key: 'he' },
    { name: 'Hiligaynon', key: 'hil' },
    { name: 'Hindi', key: 'hi' },
    { name: 'Hmong', key: 'hmn' },
    { name: 'Hungarian', key: 'hu' },
    { name: 'Hunsrik', key: 'hrx' },
    { name: 'Icelandic', key: 'is' },
    { name: 'Igbo', key: 'ig' },
    { name: 'Iloko', key: 'ilo' },
    { name: 'Indonesian', key: 'id' },
    { name: 'Irish', key: 'ga' },
    { name: 'Italian', key: 'it' },
    { name: 'Japanese', key: 'ja' },
    { name: 'Javanese', key: 'jv' },
    { name: 'Kannada', key: 'kn' },
    { name: 'Kapampangan', key: 'pam' },
    { name: 'Kazakh', key: 'kk' },
    { name: 'Khmer', key: 'km' },
    { name: 'Kiga', key: 'cgg' },
    { name: 'Kinyarwanda', key: 'rw' },
    { name: 'Kituba', key: 'ktu' },
    { name: 'Konkani', key: 'gom' },
    { name: 'Korean', key: 'ko' },
    { name: 'Krio', key: 'kri' },
    { name: 'Kurdish (Kurmanji)', key: 'ku' },
    { name: 'Kurdish (Sorani)', key: 'ckb' },
    { name: 'Kyrgyz', key: 'ky' },
    { name: 'Lao', key: 'lo' },
    { name: 'Latvian', key: 'lv' },
    { name: 'Limburgan', key: 'li' },
    { name: 'Lingala', key: 'ln' },
    { name: 'Lithuanian', key: 'lt' },
    { name: 'Lombard', key: 'lmo' },
    { name: 'Luo', key: 'luo' },
    { name: 'Luxembourgish', key: 'lb' },
    { name: 'Macedonian', key: 'mk' },
    { name: 'Maithili', key: 'mai' },
    { name: 'Makassar', key: 'mak' },
    { name: 'Malagasy', key: 'mg' },
    { name: 'Malay', key: 'ms' },
    { name: 'Malay (Jawi)', key: 'ms-Arab' },
    { name: 'Malayalam', key: 'ml' },
    { name: 'Maltese', key: 'mt' },
    { name: 'Marathi', key: 'mr' },
    { name: 'Meiteilon (Manipuri)', key: 'mni-Mtei' },
    { name: 'Minang', key: 'min' },
    { name: 'Mongolian', key: 'mn' },
    { name: 'Myanmar (Burmese)', key: 'my' },
    { name: 'Ndebele (South)', key: 'nr' },
    { name: 'Nepalbhasa (Newari)', key: 'new' },
    { name: 'Nepali', key: 'ne' },
    { name: 'Northern Sotho (Sepedi)', key: 'nso' },
    { name: 'Norwegian', key: 'no' },
    { name: 'Nuer', key: 'nus' },
    { name: 'Odia (Oriya)', key: 'or' },
    { name: 'Oromo', key: 'om' },
    { name: 'Pangasinan', key: 'pag' },
    { name: 'Pashto', key: 'ps' },
    { name: 'Persian', key: 'fa' },
    { name: 'Polish', key: 'pl' },
    { name: 'Portuguese', key: 'pt' },
    { name: 'Portuguese (Brazil)', key: 'pt-BR' },
    { name: 'Punjabi', key: 'pa' },
    { name: 'Punjabi (Shahmukhi)', key: 'pa-Arab' },
    { name: 'Quechua', key: 'qu' },
    { name: 'Romani', key: 'rom' },
    { name: 'Romanian', key: 'ro' },
    { name: 'Rundi', key: 'rn' },
    { name: 'Russian', key: 'ru' },
    { name: 'Samoan', key: 'sm' },
    { name: 'Sango', key: 'sg' },
    { name: 'Serbian', key: 'sr' },
    { name: 'Sesotho', key: 'st' },
    { name: 'Shan', key: 'shn' },
    { name: 'Shona', key: 'sn' },
    { name: 'Sicilian', key: 'scn' },
    { name: 'Sindhi', key: 'sd' },
    { name: 'Sinhala (Sinhalese)', key: 'si' },
    { name: 'Slovak', key: 'sk' },
    { name: 'Slovenian', key: 'sl' },
    { name: 'Somali', key: 'so' },
    { name: 'Spanish', key: 'es' },
    { name: 'Sundanese', key: 'su' },
    { name: 'Swahili', key: 'sw' },
    { name: 'Swati', key: 'ss' },
    { name: 'Swedish', key: 'sv' },
    { name: 'Tajik', key: 'tg' },
    { name: 'Tamil', key: 'ta' },
    { name: 'Tatar', key: 'tt' },
    { name: 'Telugu', key: 'te' },
    { name: 'Thai', key: 'th' },
    { name: 'Tigrinya', key: 'ti' },
    { name: 'Tsonga', key: 'ts' },
    { name: 'Tswana', key: 'tn' },
    { name: 'Turkish', key: 'tr' },
    { name: 'Turkmen', key: 'tk' },
    { name: 'Twi (Akan)', key: 'ak' },
    { name: 'Ukrainian', key: 'uk' },
    { name: 'Urdu', key: 'ur' },
    { name: 'Uyghur', key: 'ug' },
    { name: 'Uzbek', key: 'uz' },
    { name: 'Vietnamese', key: 'vi' },
    { name: 'Xhosa', key: 'xh' },
    { name: 'Yiddish', key: 'yi' },
    { name: 'Yoruba', key: 'yo' },
    { name: 'Zulu', key: 'zu' }
  ]
}
